module.exports = __webpack_public_path__ + "static/media/google-play-logo-176x64.95bec27b.png";